import React from "react";

const FormError = ({ err_status, err_msg }) => {
  return <p style={{ color: "#c02e26" }}>{err_status ? err_msg : ""}</p>;
};

export default FormError;
